import { useState } from 'react'

const useWebhookState = (
  intent: any,
  intentIndex: any,
  inputJson: any[],
  setInputJson: React.Dispatch<React.SetStateAction<any[]>>,
  config: any
) => {
  const [isWebhookChecked, setIsWebhookChecked] = useState(!!intent.fulfillment)

  const handleWebhookCheckboxChange = () => {
    const newInputJson = Array.from(inputJson)

    // Check if webhook input is checked and config.webhook.isEnabled is true
    if (!isWebhookChecked && !!config?.webhook?.isEnabled) {
      // Checkbox is being checked and webhook is enabled, set the default payload
      newInputJson[intentIndex] = {
        ...intent,
        fulfillment: {
          action: '',
          parameters: {
            details: '{previousValue:1}'
          },
          fallbackIntent: {
            message: '',
            intent: {}
          }
        }
      }
    } else {
      // Checkbox is being unchecked or webhook is disabled, remove the fulfillment key
      const { fulfillment, ...rest } = intent
      newInputJson[intentIndex] = rest
    }

    setInputJson(newInputJson)
    setIsWebhookChecked(!isWebhookChecked)
  }

  const handleFulfillmentChange = (key: any, value: any) => {
    const newInputJson = Array.from(inputJson)
    newInputJson[intentIndex] = {
      ...intent,
      fulfillment: {
        ...intent.fulfillment,
        [key]: value
      }
    }
    setInputJson(newInputJson)
  }

  return { isWebhookChecked, handleWebhookCheckboxChange, handleFulfillmentChange }
}

export default useWebhookState
